<template>
  <div>
    <!-- Desktop -->
    <div class="d-none d-lg-block pl-3">
      <f-card :no-body="true" class="mb-4" id="buy-box-desktop">
        <f-card-header class="font-weight-bold" id="buy-box-header">
          Passe Dein Auto Abo flexibel an
        </f-card-header>

        <f-card-body>
          <form method="post" :action="checkoutRoute" name="checkout">
            <div class="mb-1">
              <div class="form-group d-none d-md-block">
                <label for="mileage-desktop" class="font-weight-bold">Kilometerpaket</label>
                <select name="mileage" id="mileage-desktop" class="form-control custom-select"
                        v-model="mileage_selected">
                  <option v-for="(mileage, index) in mileages" v-bind:value="mileage.mileage">
                    {{ mileage.mileage }} km/Monat
                  </option>
                </select>
              </div>
            </div>

            <p class="mb-3">
              <i class="fas fa-check text-primary-cat2"></i>
              monatlich wechselbar
            </p>

            <div class="mb-1">
              <div class="form-group d-none d-md-block">
                <label for="duration-desktop" class="font-weight-bold">{{ durationLabel }}</label>
                <select name="duration" id="duration-desktop" class="form-control custom-select"
                        v-model="duration_selected">
                  <option v-for="(duration, index) in durationOptions"
                          v-bind:value="duration.minimum_duration">
                    {{ duration.minimum_duration }} Monate
                  </option>
                </select>
              </div>
            </div>

            <p v-if="!fixedDuration" class="mb-0">
              <i class="fas fa-check text-primary-cat2"></i>
              im Anschluss monatlich kündbar
            </p>
            <p v-else class="mb-0">
              <i class="fas fa-check text-primary-cat2"></i>
              Abo endet nach gebuchter Laufzeit
            </p>
            <p class="mb-0 text-primary-cat2 font-weight-bold" style="color: rgb(30, 30, 45);"
               v-if="fixedDuration">
              <i class="fas fa-check text-primary-cat2"></i>
              <span>Keine Kündigung notwendig</span>
            </p>
            <p class="mb-0 text-primary-cat2 font-weight-bold" style="color: rgb(30, 30, 45);"
               v-else-if="isShortestDurationInSelectedMileage">
              <i class="fas fa-check text-primary-cat2"></i>
              <span>Du wählst maximale Flexibilität</span>
            </p>
            <p class="mb-0 text-primary-cat2 font-weight-bold" style="color: rgb(30, 30, 45)"
               v-else-if="savings > 0">
              <i class="fas fa-check text-primary-cat2"></i>
              <span>Du sparst {{ savingsFormatted }} pro Monat</span>
            </p>
            <p data-toggle="tooltip" :data-template="tooltipTemplate" data-placement="bottom" data-html=true
               :title="tooltipContent">
              <i class="far fa-info-circle"></i>
              <u>Informationen zu den Laufzeiten</u>
            </p>

            <p class="font-weight-bold mb-0">Dein All-Inclusive Preis</p>

            <div v-if="hasValidCampaignPrice" class="strike-price-box">
              <p class="price-offer">
                <span class="price">{{ campaignPrice }}</span> / Monat inkl. MwSt.
              </p>
              <p class="strike-price">
                statt
                <span class="price">{{ strikePriceFormatted }} </span>
              </p>
            </div>

            <p v-else style="font-size: 1.6rem !important; margin-bottom: 0px;">
              {{ priceFormatted }} / Monat inkl. MwSt.
            </p>

            <p class="mb-0">
              <i class="fas fa-check text-primary-cat2"></i>
              alles inklusive bis auf Sprit
            </p>
            <p class="mb-4">
              <span data-toggle="tooltip" data-placement="bottom"
                    :title="subscriptionFactorTooltipContent">
                <i class="far fa-info-circle text-primary-cat2"></i>
              </span> Abo-Faktor: {{ subscriptionFactor }}
            </p>

            <div class="mb-4 w-100"  v-if="this.leadsCheckout && this.leadsCheckoutUrl">
              <a :href="this.leadsCheckoutUrl" class="btn btn-primary w-100 mb-3" target="_blank" rel="noopener noreferrer">
                Jetzt abonnieren <i class="far fa-external-link"></i>
              </a>

              <div class="w-100 color-tertiary-light rounded p-4 d-flex info-box-leads">
                <div class="pr-2">
                  <i class="fal fa-info-circle"></i>
                </div>

                <div>
                  <small><b>Dieses Abo wird von einem Partner angeboten. Nach dem Klick auf "Jetzt abonnieren” wirst du zur Buchung auf die Partnerseite weitergeleitet.</b></small>
                </div>
              </div>
            </div>

            <div v-else>
              <div class="mb-4 w-100">
                <checkout-init-form
                    :checkout-route="checkoutRoute"
                    :mileage-id="pricePlan_selected.mileage_id"
                    :mileage-value="pricePlan_selected.mileage"
                    :duration-id="pricePlan_selected.duration_id"
                    :duration-value="pricePlan_selected.minimum_duration"
                    :vehicle="vehicle"
                    :price="price"
                    :csrf="csrf"
                    :comes-from-iframe="comesFromIframe"
                ></checkout-init-form>
              </div>
            </div>
          </form>
          <div v-if="!this.leadsCheckout">
            <span class="font-weight-bold">Der Partner bietet folgende Zahlungsmöglichkeiten an</span>
            <div class="row pt-2">
              <div class="col-3" v-if="sepaEnabled === '1'">
                <img :src="`${imagePath}/sepa.svg`"
                     alt="Sepa Logo" class="img-fluid buybox-payment">
              </div>
              <div class="col-3">
                <img :src="`${imagePath}/mastercard.svg`"
                     alt="Mastercard Logo" class="img-fluid buybox-payment">
              </div>
              <div class="col-3">
                <img :src="`${imagePath}/visa.svg`"
                     alt="Visa Logo" class="img-fluid buybox-payment">
              </div>
              <div class="col-3">
                <img :src="`${imagePath}/american_express.svg`"
                     alt="American Express Logo" class="img-fluid buybox-payment">
              </div>
            </div>
          </div>
        </f-card-body>
      </f-card>
    </div>

    <!-- Mobile -->
    <div class="d-sm-block d-lg-none">
      <f-card :no-body="true" class="mb-4" id="buy-box-mobile">
        <f-card-body>
          <form method="post" :action="checkoutRoute" name="checkout">
            <div class="mb-1">
              <div class="form-group">
                <label for="mileage-mobile" class="font-weight-bold"   >Kilometerpaket</label>
                <select name="mileage" id="mileage-mobile" class="form-control custom-select"
                        v-model.number="mileage_selected">
                  <option v-for="(mileage, index) in mileages" v-bind:value="mileage.mileage">
                    {{ mileage.mileage }} km/Monat
                  </option>
                </select>
              </div>
            </div>

            <p class="mb-3">
              <i class="fas fa-check text-primary-cat2"></i>
              monatlich wechselbar
            </p>

            <div class="mb-1">
              <div class="form-group">
                <label for="duration-mobile" class="font-weight-bold">{{ durationLabel }}</label>
                <select name="duration" id="duration-mobile" class="form-control custom-select"
                        v-model.number="duration_selected">
                  <option v-for="(duration, index) in durationOptions"
                          v-bind:value="duration.minimum_duration">
                    {{ duration.minimum_duration }} Monate
                  </option>
                </select>
              </div>
            </div>


            <p v-if="!fixedDuration" class="mb-0">
              <i class="fas fa-check text-primary-cat2"></i>
              im Anschluss monatlich kündbar
            </p>
            <p v-else class="mb-0">
              <i class="fas fa-check text-primary-cat2"></i>
              Abo endet nach gebuchter Laufzeit
            </p>
            <p class="mb-0 text-primary-cat2 font-weight-bold" style="color: rgb(30, 30, 45);"
               v-if="fixedDuration">
              <i class="fas fa-check text-primary-cat2"></i>
              <span>Keine Kündigung notwendig</span>
            </p>
            <p class="mb-0 text-primary-cat2 font-weight-bold" style="color: rgb(30, 30, 45);"
               v-else-if="isShortestDurationInSelectedMileage">
              <i class="fas fa-check text-primary-cat2"></i>
              <span>Du wählst maximale Flexibilität</span>
            </p>
            <p class="mb-0 text-primary-cat2 font-weight-bold" style="color: rgb(30, 30, 45);"
               v-else-if="savings > 0">
              <i class="fas fa-check text-primary-cat2"></i>
              <span>Du sparst {{ savingsFormatted }} pro Monat</span>
            </p>
            <p data-toggle="tooltip" :data-template="tooltipTemplate" data-placement="bottom" data-html=true
               :title="tooltipContent">
              <i class="far fa-info-circle"></i>
              <u>Informationen zu den Laufzeiten</u>
            </p>
            <p class="font-weight-bold mb-0">Dein All-Inclusive Preis</p>
            <div v-if="hasValidCampaignPrice" class="strike-price-box">
              <p class="price-offer">
                <span class="price">{{ campaignPrice }}</span> / Monat inkl. MwSt.
              </p>
              <p class="strike-price">
                statt
                <span class="price">{{
                    strikePriceFormatted
                  }}</span>
              </p>
            </div>

            <p v-else style="font-size: 1.6rem !important; margin-bottom: 0px;">
              {{ priceFormatted }} / Monat inkl. MwSt.
            </p>

            <p class="mb-0">
              <i class="fas fa-check text-primary-cat2"></i>
              alles inklusive bis auf Sprit
            </p>
            <p class="mb-4">
              <span data-toggle="tooltip" data-placement="bottom"
                    :title="subscriptionFactorTooltipContent">
                <i class="far fa-info-circle text-primary-cat2"></i>
              </span> Abo-Faktor: {{ subscriptionFactor }}
            </p>

            <div class="mb-4 w-100"  v-if="this.leadsCheckout && this.leadsCheckoutUrl">
              <a :href="this.leadsCheckoutUrl" class="btn btn-primary w-100 mb-3" target="_blank" rel="noopener noreferrer">
                Jetzt abonnieren <i class="far fa-external-link"></i>
              </a>

              <div class="w-100 color-tertiary-light rounded p-4 d-flex info-box-leads">
                <div class="pr-2">
                  <i class="fal fa-info-circle"></i>
                </div>

                <div>
                  <small><b>Dieses Abo wird von einem Partner angeboten. Nach dem Klick auf "Jetzt abonnieren” wirst du zur Buchung auf die Partnerseite weitergeleitet.</b></small>
                </div>
              </div>
            </div>

            <div v-else>
              <div class="mb-4 w-100">
                <checkout-init-form
                    :checkout-route="checkoutRoute"
                    :mileage-id="pricePlan_selected.mileage_id"
                    :mileage-value="pricePlan_selected.mileage"
                    :duration-id="pricePlan_selected.duration_id"
                    :duration-value="pricePlan_selected.minimum_duration"
                    :vehicle="vehicle"
                    :price="price"
                    :csrf="csrf"
                    :comes-from-iframe="comesFromIframe"
                ></checkout-init-form>
              </div>
            </div>
          </form>
          <div v-if="!this.leadsCheckout && !this.leadsCheckoutUrl">
            <span class="font-weight-bold">Der Partner bietet folgende Zahlungsmöglichkeiten anhihi</span>
            <div class="row pt-2">
              <div class="col-3" v-if="sepaEnabled === '1'" style="padding-left: 1rem; padding-right: 0.5rem; width: 15%;">
                <img :src="`${imagePath}/sepa.svg`"
                     alt="Sepa Logo" class="img-fluid buybox-payment px-2"
                >
              </div>
              <div class="col-3" style="padding-left: 1rem; padding-right: 0.5rem; width: 15%;">
                <img :src="`${imagePath}/mastercard.svg`"
                     alt="Mastercard Logo" class="img-fluid buybox-payment px-2">
              </div>
              <div class="col-3" style="padding-left: 1rem; padding-right: 0.5rem; width: 15%;">
                <img :src="`${imagePath}/visa.svg`"
                     alt="Visa Logo" class="img-fluid buybox-payment px-2">
              </div>
              <div class="col-3" style="padding-left: 1rem; padding-right: 0.5rem; width: 15%;">
                <img :src="`${imagePath}/american_express.svg`"
                     alt="American Express Logo" class="img-fluid buybox-payment px-2">
              </div>
            </div>
          </div>
        </f-card-body>
      </f-card>
    </div>

    <!-- Sticky -->
    <div class="bg-white shadow d-lg-none sticky" id="buybox-sticky" :style="{display: stickyBuyBoxStyles}">
      <div class="container">
        <div class="row justify-content-between align-items-center p-1 mt-1">
          <div class="col-6">

            <div v-if="hasValidCampaignPrice" class="strike-price-box">
              <p class="price-offer">
                <span class="price">{{ priceFormatted }}</span> / Monat inkl. MwSt.
              </p>
              <p class="strike-price">
                statt
                <span class="price">{{ strikePriceFormatted }}</span>
              </p>
            </div>
            <p v-else style="font-size: 1.4rem !important; margin-bottom: 0px; line-height: 1.4">
              {{ priceFormatted }} / Monat inkl. MwSt.
            </p>
            <p class="mb-0">
              <i class="fas fa-check text-primary-cat2"></i>
              alles inklusive bis auf Sprit
            </p>
          </div>
          <div class="col-6">
            <checkout-init-form
                :checkout-route="checkoutRoute"
                :mileage-id="pricePlan_selected.mileage_id"
                :mileage-value="pricePlan_selected.mileage"
                :duration-id="pricePlan_selected.duration_id"
                :duration-value="pricePlan_selected.minimum_duration"
                :vehicle="vehicle"
                :price="price"
                :comes-from-iframe="comesFromIframe"
                :csrf="csrf"
            ></checkout-init-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "BuyBox",
  props: {
    listingPrice: {
      type: String,
      required: true
    },
    imagePath: {
      type: String,
      required: false,
      default: "https://storage.googleapis.com/faa-files/payment-options"
    },
    sepaEnabled: {
      type: String,
      required: false,
      default: '0'
    },
    pricePlans: {
      type: Array,
      required: false,
      default: []
    },
    fixedDuration: {
      type: Boolean,
      required: false,
      default: true
    },
    checkoutRoute: {
      type: String,
      required: true
    },
    vehicle: {
      type: Object,
      required: true
    },
    campaign: {
      type: Object,
      required: false
    },
    currency: {
      type: String,
      required: false,
      default: "EUR"
    },
    locale: {
      type: String,
      required: false,
      default: "de-DE"
    },
    country: {
      type: String,
      required: false,
      default: "Switzerland"
    },
    leadsCheckout: {
      type: String,
      required: false,
      default: false
    },
    leadsCheckoutUrl: {
      type: String,
      required: false,
      default: ''
    }

  },
  mounted() {
    this.$nextTick(() => {
      this.rendered = true
    })
  },
  data () {
    return {
      rendered: false,
      mileages: [],
      durations: {},
      mileage_selected: '',
      duration_selected: '',
      pricePlan_selected: '',
      stickyBuyBoxStyles: "none",
      csrf: document
          .querySelector ('meta[name="csrf-token"]')
          .getAttribute ("content"),
      tooltipContent: '<div class="duration-filter-tooltip">\n' +
          '            <p class="py-1 mb-0">\n' +
          '\n' +
          '              <b>Mindestlaufzeit:</b> Du fährst so lange du willst und kannst nach der gebuchten Laufzeit monatlich kündigen.</br>\n' +
          '              <b>Feste Laufzeit:</b> Das Fahrzeug muss nach der gebuchten Laufzeit zurück an den Partner übergeben werden.</br>\n' +
          '              <b>Tipp:</b> Nutze im Katalog unseren “Abo-Laufzeit”-Filter um nur Fahrzeuge mit zu dir passender Laufzeit präsentiert zu bekommen.' +
          '            </p></div>',
      tooltipTemplate: '<div class="tooltip duration-tooltip" role="tooltip">\n' +
          '              <div class="arrow"></div>\n' +
          '              <div class="tooltip-inner"></div>\n' +
          '            </div>',
      subscriptionFactorTooltipContent: 'Der Abo-Faktor zeigt, wie attraktiv ein Angebot ist. Der Abo-Faktor gibt das Verhältnis von der Abo-Rate und Bruttolistenpreis des Fahrzeuges an. Die Laufzeit und das km-Paket beeinflussen die Abo-Rate und somit den Abo-Faktor. Je niedriger der Faktor, desto besser das Angebot.',
			isActiveCampaign: false
    }
  },

  computed: {
    comesFromIframe () {
      const queryString = window.location.search
      const urlParams = new URLSearchParams (queryString)

      switch (urlParams.get ('source')) {
        case "producer_iframe":
          return true
        default:
          return false
      }
    },
    /**
     * Checks if params for duration and mileage are given in the url and if there is a fitting price plan on this vehicle
     * @returns {boolean}
     */
    urlHasValidParams () {
      const givenMileage = parseInt (this.getUrlParam ("mileage"))
      const givenDuration = parseInt (this.getUrlParam ("duration"))

      if (givenMileage > 0 && givenDuration > 0) {
        let pricePlan = this.getPricePlanByMileageIdAndDurationId (givenMileage, givenDuration)
        return typeof pricePlan !== "undefined"
      } else {
        return false
      }
    },
    durationOptions () {
      return this.durations[this.mileage_selected]
    },
    priceFormatted () {
      return this.getFormattedPrice (this.price)
    },
    price () {
      if (this.isActiveCampaign && this.pricePlan_selected.has_campaign_price && this.pricePlan_selected.campaign_price > 0) {
        return this.pricePlan_selected.campaign_price
      }
      return this.pricePlan_selected.price
    },
    strikePrice () {
      return this.pricePlan_selected.price
    },
    strikePriceFormatted () {
      return this.getFormattedPrice (this.strikePrice)
    },
    subscriptionFactor() {
      const subscriptionFactor = (this.price / parseFloat(this.listingPrice)  * 100).toFixed(1)
      const formattedSubscriptionFactor = subscriptionFactor.toString().replace(".", ",")
      return formattedSubscriptionFactor
    },
    savingsFormatted () {
      return this.getFormattedPrice (this.savings)
    },
    savings () {
      let pricePlansForCurrentMileage = _.filter (this.pricePlans, o => {
        return o.mileage === this.mileage_selected
      })

      let mostExpensivePricePlan = _.maxBy (pricePlansForCurrentMileage, o => {
        return o.price
      })

      let comparePrice = mostExpensivePricePlan.price
      if (this.isActiveCampaign && mostExpensivePricePlan.has_campaign_price && mostExpensivePricePlan.campaign_price > 0) {
        comparePrice = mostExpensivePricePlan.campaign_price
      }

      return comparePrice - this.price
    },
    isShortestDurationInSelectedMileage () {
      let pricePlansForCurrentMileage = _.filter (this.pricePlans, o => {
        return o.mileage === this.mileage_selected
      })

      let lowestPricePlan = _.minBy (pricePlansForCurrentMileage, o => {
        return o.minimum_duration
      })

      return lowestPricePlan.minimum_duration === this.duration_selected
    },
    hasValidCampaignPrice () {
      return this.pricePlan_selected.has_campaign_price && this.isActiveCampaign
          && this.pricePlan_selected.price > this.pricePlan_selected.campaign_price
          && this.pricePlan_selected.campaign_price > 0
    },
    campaignPrice () {
      return this.getFormattedPrice (this.pricePlan_selected.campaign_price)
    },
    scrollLimitPosition () {
      return document.getElementById ("scrollToLimitBuyBox").getBoundingClientRect ().y + window.pageYOffset
    },

    durationLabel () {
      return this.fixedDuration ? 'Feste Laufzeit' : 'Mindestlaufzeit'
    }
  },

  watch: {
    mileage_selected (newMileage, oldMileage) {
      if (newMileage !== oldMileage && this.rendered) {
        this.pricePlan_selected = this.lowestPricePlan (newMileage)
        this.duration_selected = this.pricePlan_selected.minimum_duration
      }
    },
    duration_selected (newDuration, oldDuration) {
      if (newDuration !== oldDuration) {
        this.pricePlan_selected = this.getPricePlanByMileageAndDuration (this.mileage_selected, newDuration)
      }
    },
    pricePlan_selected (newPlan, oldPlan) {
      //Google Tag Manager

      if(window.dataLayer !== undefined){
        window.dataLayer.push ({
          'event': 'productDetailView',
          'ecommerce': {
            'detail': {
              'products': [{
                'name': this.vehicle.title,         // Name or ID is required.
                'id': this.vehicle.id,
                'price': this.price,
                'brand': this.vehicle.brand,
                'category': this.vehicle.category,
                'mileage': this.pricePlan_selected.mileage,
                'duration': this.pricePlan_selected.minimum_duration,
                'subsidiaryId': this.vehicle.subsidiaryId
              }]
            }
          }
        })
      }
    }
  },

  methods: {
    getFormattedPrice (price) {
      return new Intl.NumberFormat (this.locale, {
        style: 'currency',
        currency: this.pricePlan_selected.currency.iso
      }).format (price)
    },
    getPricePlanByMileageIdAndDurationId (mileageId, durationId) {
      return _.find (this.pricePlans, o => {
        return o.mileage_id === mileageId && o.duration_id === durationId
      })
    },
    getPricePlanByMileageAndDuration (mileage, duration) {
      return _.find (this.pricePlans, o => {
        return o.mileage === mileage && o.minimum_duration === duration
      })
    },
    lowestPricePlan (mileage = null) {
      if (mileage !== null) {
        let pricePlansForGivenMileage = _.filter (this.pricePlans, o => {
          return o.mileage === mileage
        })
        let lowestPricePlanForGivenMileage = _.minBy (pricePlansForGivenMileage, o => {
          return o.price
        })

        if (typeof lowestPricePlanForGivenMileage !== "undefined" || lowestPricePlanForGivenMileage !== null) {
          return lowestPricePlanForGivenMileage
        }
      }
      return _.minBy (this.pricePlans, o => {
        return o.price
      })
    },
    getUrlParam (key) {
      var result = null,
          tmp = [];
      location.search
          .substr (1)
          .split ("&")
          .forEach (item => {
            tmp = item.split ("=");
            if (tmp[0] === key) result = decodeURIComponent (tmp[1]);
          });
      return result;
    },
    showBuyBoxStickyMobile (event) {
      const scrollPosition = window.scrollY
      if (scrollPosition > this.scrollLimitPosition) {
        this.stickyBuyBoxStyles = "flex"
      } else {
        this.stickyBuyBoxStyles = "none"
      }
    },
    async checkIfCampaignActive() {
      if(this.pricePlan_selected.has_campaign_price) {
        let isActive = false;

        try {
          const response = await fetch('/api/v1.0/vehicles/is-in-active-campaign/' + this.vehicle.id);
          const data = await response.json();
          isActive = data;
        } catch (error) {
        }

        if(isActive){
          this.isActiveCampaign = isActive
        }
      }
    },
  },

  destroyed () {
    window.removeEventListener ('scroll', this.showBuyBoxStickyMobile);
  },

  beforeMount () {
    let self = this
    let mileages = _.groupBy (this.pricePlans, 'mileage')

    _.forEach (mileages, (options, key) => {
      self.durations[key] = options

      let option = _.find (options, o => {
        return parseInt (o.mileage) === parseInt (key)
      })
      self.mileages.push ({
        key: option.mileage,
        mileage: option.mileage
      })
    })

    if (this.urlHasValidParams) {
      // => set preset values
      // Get values from URL
      let givenMileageId = parseInt (this.getUrlParam ('mileage'))
      let givenDurationId = parseInt (this.getUrlParam ('duration'))

      // Get price plan
      this.pricePlan_selected = this.getPricePlanByMileageIdAndDurationId (givenMileageId, givenDurationId)
    } else {
      // => set lowest available price plan
      this.pricePlan_selected = this.lowestPricePlan ()
    }
    // Set values for the selected options
    this.mileage_selected = this.pricePlan_selected.mileage
    this.duration_selected = this.pricePlan_selected.minimum_duration


    window.addEventListener ('scroll', this.showBuyBoxStickyMobile)

    if(window.dataLayer !== undefined){
      window.dataLayer.push ({
        'event': 'productClick',
        'ecommerce': {
          'click': {
            'products': [{
              'name': this.vehicle.title,         // Name or ID is required.
              'id': this.vehicle.id,
              'price': this.price,
              'brand': this.vehicle.brand,
              'category': this.vehicle.category,
              'mileage': this.pricePlan_selected.mileage,
              'duration': this.pricePlan_selected.minimum_duration,
              'subsidiaryId': this.vehicle.subsidiaryId
            }]
          }
        },
      })
    }

    this.checkIfCampaignActive();
  }
}
</script>

<style scoped lang="scss">
.info-box-leads {
  background-color: #c5eff4;
  color: #36acbb;
}
#buy-box-mobile {
  border: none;
}

.strike-price-box {
  .price-offer {
    font-size: 1.6rem !important;
    margin-bottom: 0px;
  }

  .price {
    font-weight: 700;
    color: #ff0000
  }

  .strike-price {
    font-size: 16px;
    margin-top: -10px;
    margin-bottom: 10px;

    .price {
      text-decoration: line-through;
      color: #969696;
      font-weight: normal;
    }
  }
}

#buybox-sticky {
  .strike-price-box {
    .price-offer {
      font-size: 1.4rem !important;
      margin-bottom: 0px;
    }

    .price {
      font-weight: 700;
      color: #ff0000
    }

    .strike-price {
      font-size: 16px;
      margin-top: -10px;
      margin-bottom: 0;

      .price {
        text-decoration: line-through;
        color: #1E1E2D;
        font-weight: normal;
      }
    }
  }
}

.sticky {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
</style>
